import { withStyles } from '@material-ui/core/styles';
import { WARRANTY_LIST_TITLE } from '../../libraries/texts';
import WarranryService from '../../services/warranty-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(
  ListForm({ service: WarranryService, title: WARRANTY_LIST_TITLE, name: 'WARRANTY' })
);
